import { Gender } from 'common/enum/gender'
import { Doctor } from 'domain/entities/doctor-model'
import moment from 'moment-timezone'
import * as yup from 'yup'
import 'main/config/yup'

interface UpdatePatientData {
  patient_id: number
  name?: string
  socialName?: string
  gender?: Gender
  birthday?: string
  rg?: string
  cpf?: string
  email?: string
  phone?: string
  maritalStatus?: string
  company?: string
  religion?: string
  religion_id?: number
}

export interface UpdateAccompanyingData {
  accompanying_id: number
  name: string
  socialName?: string
  phone: string
  email: string
  sendSMS?: boolean
  sendEmail?: boolean
  isMain?: boolean
}

export interface EmergencyRoomEditFormikValues {
  updatePatient: UpdatePatientData
  updateAccompanying?: UpdateAccompanyingData
  isEditing: boolean
  useDefaultDoctor?: boolean
  doctor?: Partial<Doctor>
}

export const emergencyRoomValidationSchema = yup.object().shape({
  updateAccompanying: yup
    .object()
    .nullable()
    .optional()
    .shape({
      accompanying_id: yup.number().nullable().optional(),
      name: yup
        .string()
        .nullable()
        .optional()
        .when('accompanying_id', {
          is: (value?: number) => value,
          then: yup.string().required()
        }),
      phone: yup
        .string()
        .nullable()
        .optional()
        .when('accompanying_id', {
          is: (value?: number) => value,
          then: yup.string().required()
        }),
      email: yup
        .string()
        .nullable()
        .optional()
        .when('accompanying_id', {
          is: (value?: number) => value,
          then: yup.string().email().required()
        })
    }),
  updatePatient: yup.object().shape({
    patient_id: yup.number().required(),
    name: yup.string().required(),
    birthday: yup
      .date()
      .format('DD/MM/YYYY', true)
      .required()
      .typeError('Data inválida')
      .test('lesser_then_today', 'Insira uma data válida.', (value) => {
        if (value) {
          const date = moment(value, 'DD/MM/YYYY').startOf('day')
          const now = moment().startOf('day')
          if (date.isValid()) {
            return date <= now
          }
        }
        return true
      }),
    gender: yup.string().required(),
    email: yup.string().email().required(),
    maritalStatus: yup.string().required()
  }),
  useDefaultDoctor: yup.boolean().nullable().optional().when('isEditing', {
    is: false,
    then: yup.boolean().required()
  }),
  isEditing: yup.boolean().nullable().optional(),
  doctor: yup
    .object()
    .nullable()
    .optional()
    .when('useDefaultDoctor', {
      is: false,
      then: yup.object().shape({
        doctor_id: yup.number().required()
      })
    })
})
